import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import {
  IApnMassActivationSpaceEmailLink,
  IApnSpaceEmailLink,
  ILotList,
  IParkerActivationReturnData,
  IParkersReadyForactivation,
} from 'src/app/shared/interfaces';
import { environment } from 'src/environments/environment';
import { ParkerV2AccountsToActivateComponent } from './parker-v2-accounts-to-activate/parker-v2-accounts-to-activate.component';
import { ParkerV2NonActiveSpaceAccountsComponent } from './parker-v2-non-active-space-accounts/parker-v2-non-active-space-accounts.component';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { AppGeneralStateService } from 'src/app/app-general-state.service';

@Component({
  selector: 'app-space-links',
  templateUrl: './parker-v2-space-links.component.html',
  styleUrl: './parker-v2-space-links.component.scss',
  standalone: true,
  imports: [
    MatIconModule,
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ParkerV2AccountsToActivateComponent,
    ParkerV2NonActiveSpaceAccountsComponent,
    NgIf,
    MatButtonModule,
  ],
})
export class ParkerV2SpaceLinksComponent implements OnInit {
  isUserAdmin: boolean = false;
  userName: string = '';
  LotListByUserName: ILotList[] = [];
  lotNumber: string = '';
  parkerActivationList: IParkersReadyForactivation[] = [];
  selectedLot: string = '';
  gridFontSize: number = 12;
  numberOfParkersSelected: number = 0;
  allParkersChecked: boolean = false;
  newSpaceEmailLinkData: IApnMassActivationSpaceEmailLink[] = [];
  parkerActivationReturnData: IParkerActivationReturnData[] = [];
  isProcessingNewUsers: boolean = false;
  lotDisplayName: string = '';
  urlDomain: string = '';
  queryType: string = '0';

  //Services
  _appGeneralState = inject(AppGeneralStateService);

  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private _parkerState: ParkerStateService,
    private routerService: Router,
  ) {
    this.userName = this._appGeneralState.userName;
    // this.urlDomain = environment.UrlDomain;
    // if(this.userName === ''){
    //   this.routerService.navigate([`/badroute`]);
    // }
  }

  ngOnInit(): void {
    this.lotNumber = this._appGeneralState.currentLotNumber;
    this.lotDisplayName = this._appGeneralState.currentLotNumber + ' - ' + this._appGeneralState.currentLotName;
    //  this.getSpaceIdByEmailAddress(this.userName);
    //  this.queryType = '0';
  }

  onNavToParkersHome(): void {
    this.routerService.navigate([`/parkerv2`]);
  }

  isParkerFlaggedForActivation(rowIndex: number): boolean {
    return this.parkerActivationList[rowIndex].activateFlag === true;
  }

  onCheckParker(parkerId: string): void {
    let ii: number;
    let isFlagged: boolean = false;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      if (this.parkerActivationList[ii].parkerId === parkerId) {
        this.parkerActivationList[ii].activateFlag = !this.parkerActivationList[ii].activateFlag;
      }
    }

    this.setNumberOfParkersSelected();
  }

  onActivateParkers(): void {
    let ii: number = 0;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      let aNewSpaceUser: IApnMassActivationSpaceEmailLink = {} as IApnMassActivationSpaceEmailLink;
      if (this.parkerActivationList[ii].activateFlag) {
        aNewSpaceUser.emailAddress = this.parkerActivationList[ii].emailAddress;
        aNewSpaceUser.parkerId = this.parkerActivationList[ii].parkerId;
        aNewSpaceUser.lotNumber = this.parkerActivationList[ii].lotNumber;
        aNewSpaceUser.spaceUserId = 0;
        aNewSpaceUser.lastModifiedByUserId = this._appGeneralState.userName;
        aNewSpaceUser.dateLastModified = new Date().toLocaleString();

        this.newSpaceEmailLinkData.push(aNewSpaceUser);
      }
    }

    this.postNewSpaceEmail(this.newSpaceEmailLinkData);
  }

  onToggleCheckAll(): void {
    this.allParkersChecked = !this.allParkersChecked;
    let ii: number;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      this.parkerActivationList[ii].activateFlag = this.allParkersChecked;
    }

    if (this.allParkersChecked) {
      this.numberOfParkersSelected = this.parkerActivationList.length;
    } else this.numberOfParkersSelected = 0;
  }

  setNumberOfParkersSelected(): void {
    let ii: number = 0;

    this.numberOfParkersSelected = 0;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      if (this.parkerActivationList[ii].activateFlag === true) this.numberOfParkersSelected++;
    }
  }

  onQueryTypeChange(queryType: any) {
    this.parkerActivationList = [];

    this.allParkersChecked = false;

    if (queryType === '0') this.queryType = '0';
    else this.queryType = queryType;
  }

  onSubmitParkersReadyForActivation(): void {
    this.allParkersChecked = false;
    this.getParkersReadyForActivationList(this.lotNumber);
  }

  processNewUsersAfterAdding(): void {
    let ii: number;
    let jj;
    this.numberOfParkersSelected;

    for (ii = 0; ii < this.parkerActivationReturnData.length; ii++) {
      for (jj = 0; jj < this.parkerActivationList.length; jj++) {
        if (this.parkerActivationReturnData[ii].parkerId === this.parkerActivationList[jj].parkerId) {
          if (this.parkerActivationReturnData[ii].status === true) this.parkerActivationList[jj].result = 1;
          else this.parkerActivationList[jj].result = 2;
        }
      }
    }
  }

  postNewSpaceEmail(newSpaceEmailData: IApnMassActivationSpaceEmailLink[]) {
    let newSpaceEmailId: number;
    this.isProcessingNewUsers = true;
    this.dataService.postParkerActivateSpaceAccount(newSpaceEmailData).subscribe(
      (res) => {
        this.parkerActivationReturnData = res;
        this.isProcessingNewUsers = false;
      },
      (err: any) => {
        this.isProcessingNewUsers = false;
        this.newSpaceEmailLinkData = [];
      },
      () => {
        let ii: number;
        this.newSpaceEmailLinkData = [];
        this.processNewUsersAfterAdding();
      },
    );
  }

  getParkersReadyForActivationList(lotNumber: string) {
    this.dataService.getParkersReadyForActivationByLotNumber(lotNumber).subscribe(
      (parkerList) => {
        this.parkerActivationList = parkerList;
      },
      (err: any) => {},
      () => {
        let ii: number = 0;
        for (ii = 0; ii < this.parkerActivationList.length; ii++) {
          this.parkerActivationList[ii].result = 0; //0 = not submitted;
        }
      },
    );
  }

  getLotListsNotRestrictedForSpaceActivation() {
    this.dataService.GetAdminMassActivationLotList().subscribe(
      (LotListByUserName) => {
        this.LotListByUserName = LotListByUserName;
      },
      (err: any) => {},
      () => {},
    );
  }

  getSpaceIdByEmailAddress(userName: string): void {
    let spaceUserid: number;

    this.dataService.getIsUserAdmin(userName).subscribe(
      (res) => {
        this.isUserAdmin = res;
      },
      (err: any) => {},
      () => {
        if (!this.isUserAdmin) {
          this.routerService.navigate([`/badroute`]);
        }

        let userName: string = this._appGeneralState.userName;
        if (userName === 'kmoss' || userName === 'lgonzalez' || userName === 'jizigzon') {
        } else this.routerService.navigate([`/badroute`]);
      },
    );
  }
}
